import { sortBy } from 'lodash'
import { ResponseGetCountries } from '@ads/front-core/api'
import { POLAND_NAME } from '@ads/front-core/constants/countries'
import { TDictionary } from '@ads/front-core/interfaces'
import { lng } from '@ads/front-core/locales'

export const getPolandIdFromDictionary = (dictionary?: TDictionary[]) =>
  Number(dictionary?.find(c => c.value === POLAND_NAME)?.id)

export const getEUCountryCode = (
  countryId: string,
  countries: ResponseGetCountries,
) =>
  countries?.find(country =>
    country.countryCode === countryId && country.isUE ? country : null,
  )?.countryCode || ''

export const mapCountriesToDictionary = (
  countries: ResponseGetCountries,
): TDictionary[] => {
  const res = countries?.map(country => ({
    id: country.countryCode,
    value: lng(`country:${country.countryCode}` as any),
  }))
  return res ? sortBy(res, 'value') : []
}
